import { useQuery } from '@apollo/client'
import dayjs from 'dayjs'
import React from 'react'
import { Box, Flex, Image, Text } from 'rebass/styled-components'

import Price from '../../components/Price'
import { CUSTOMER_ORDERS } from '../../graphql/queries'
import { fmtImageSize, storage } from '../../utils/index'
import { IonPage, IonLoading } from '@ionic/react'
import Header from '../../components/Header'
import IonContent from '../../components/IonContent'

export default () => {
    const token = storage.getItem('accessToken')
    const { data, loading } = useQuery(CUSTOMER_ORDERS, {
        variables: {
            customerAccessToken: token,
        },
    })

    const { edges = [] } = data?.customer?.orders || {}

    return (
        <IonPage bg="#eee" px="0">
            <Header title="Order"></Header>
            <IonContent fullscreen>
                {edges.length < 1 && (
                    <Flex justifyContent="center" py="50px">
                        <Text>暂无订单</Text>
                    </Flex>
                )}
                {edges.map(({ node }, index) => (
                    <Box
                        key={index}
                        bg="#fff"
                        p="15px"
                        mb="20px"
                        key={index}
                        css={{
                            borderBottom: '1px solid #eee',
                        }}
                    >
                        <Flex justifyContent="space-between">
                            <Text fontSize="16px" fontWeight="bold">
                                #{node.orderNumber}
                            </Text>
                            <Text>{dayjs(node.processedAt).format('YYYY-MM-DD HH:mm:ss')}</Text>
                        </Flex>
                        {node.lineItems.edges.map(({ node: line }, i) => (
                            <Flex justifyContent="space-between" my="10px" key={i}>
                                <Image
                                    src={fmtImageSize(line.variant.image.src)}
                                    width="80px"
                                    flex="none"
                                    alt=""
                                />
                                <Box width="100%" pl="10px">
                                    <Text>名称：{line.title}</Text>
                                    <Text>数量：{line.quantity}</Text>
                                    <Text>
                                        价格：<Price>{line.variant.price}</Price>
                                    </Text>
                                </Box>
                            </Flex>
                        ))}
                        <Flex>
                            <Text>
                                总价格：<Price>{node.totalPrice}</Price>
                            </Text>
                            <Text ml="10px">
                                销售税：<Price>{node.totalTax}</Price>
                            </Text>
                        </Flex>
                    </Box>
                ))}

                <IonLoading isOpen={loading}></IonLoading>
            </IonContent>
        </IonPage>
    )
}
